export default {
  REFERENCE_INPUT: 'referenceInput',
  REFERENCE_INPUT_ACTION_BUTTON: 'referenceInputActionButton',
  REFERENCE_OUTPUT: 'referenceOutput',
  REFERENCE_OUTPUT_SEQUENCE: 'referenceOutputSequence',

  NEW_POSTBACK_INPUT: 'newPostbackInput',
  NEW_POSTBACK_INPUT_TRIGGER: 'newPostbackInputTrigger',
  NEW_POSTBACK_OUTPUT: 'newPostbackOutput',
  NEW_POSTBACK_OUTPUT_SEQUENCE: 'newPostbackOutputSequence',

  TRIGGER_INPUT: 'triggerInput',
  TRIGGER_OUTPUT: 'triggerOutput',

  TEXT_INPUT: 'textInput',
  TEXT_OUTPUT: 'textOutput',
  TEXT_OUTPUT_BUTTON: 'textOutputButton',
  TEXT_OUTPUT_QUICKREPLY: 'textOutputQuickreply',

  CAROUSEL_INPUT: 'carouselInput',
  CAROUSEL_OUTPUT: 'carouselOutput',
  CAROUSEL_OUTPUT_ITEMS: 'carouselItems',
  CAROUSEL_OUTPUT_QUICKREPLY: 'carouselOutputQuickreply',

  CAROUSEL_SINGLE_INPUT: 'carouselItemInput',
  CAROUSEL_SINGLE_OUTPUT: 'carouselItemOutput',
  CAROUSEL_SINGLE_OUTPUT_BUTTON: 'carouselItemOutputButton',

  COMPONENT_LIST_INPUT: 'componentListInput',

  FACEBOOK_MEDIA_INPUT: 'facebookMediaInput',
  FACEBOOK_MEDIA_OUTPUT: 'facebookMediaOutput',
  FACEBOOK_MEDIA_OUTPUT_BUTTON: 'facebookMediaOutputButton',
  FACEBOOK_MEDIA_OUTPUT_QUICKREPLY: 'facebookMediaOutputQuickreply',

  IMAGE_INPUT: 'imageInput',
  IMAGE_OUTPUT: 'imageOutput',
  IMAGE_OUTPUT_QUICKREPLY: 'imageOutQuickreply',

  VIDEO_INPUT: 'videoInput',
  VIDEO_OUTPUT: 'videoOutput',
  VIDEO_OUTPUT_QUICKREPLY: 'videoOutputQuickreply',

  AUDIO_INPUT: 'audioInput',
  AUDIO_OUTPUT: 'audioOutput',
  AUDIO_OUTPUT_QUICKREPLY: 'audioOutputQuickreply',

  FILE_INPUT: 'fileInput',
  FILE_OUTPUT: 'fileOutput',
  FILE_OUTPUT_QUICKREPLY: 'fileOutputQuickreply',

  QUICK_REPLY_INPUT: 'quickReplyInput',
  QUICK_REPLY_OUTPUT: 'quickReplyOutput',

  BUTTON_INPUT: 'buttonInput',
  BUTTON_OUTPUT: 'buttonOutput',

  OTN_INPUT: 'otnInput',
  OTN_OUTPUT: 'otnOutput',

  OTN_SINGLE_INPUT: 'otnSingleInput',
  OTN_SINGLE_OUTPUT: 'otnSingleOutput',
  OTN_SINGLE_OUTPUT_SEQUENCE: 'otnSingleOutputSequence',

  USER_INPUT_FLOW_INPUT: 'userInputFlowInput',
  USER_INPUT_FLOW_OUTPUT: 'userInputFlowOutput',

  USER_INPUT_FLOW_SINGLE_INPUT: 'userInputFlowSingleInput',
  USER_INPUT_FLOW_SINGLE_OUTPUT: 'userInputFlowSingleOutput',
  USER_INPUT_FLOW_SINGLE_OUTPUT_FINAL_REPLY: 'userInputFlowSingleOutputFinalReply',

  ECOMMERCE_INPUT: 'ecommerceInput',
  ECOMMERCE_OUTPUT: 'ecommerceOutput',
  ECOMMERCE_OUTPUT_QUICKREPLY: 'ecommerceOutputQuickreply',

  GENERIC_TEMPLATE_INPUT: 'genericTemplateInput',
  GENERIC_TEMPLATE_OUTPUT: 'genericTemplateOutput',
  GENERIC_TEMPLATE_OUTPUT_BUTTON: 'genericTemplateOutputButton',

  GENERIC_TEMPLATE_OUTPUT_QUICKREPLY: 'genericTemplateOutputQuickreply',

  SEQUENCE_INPUT: 'sequenceInput',
  SEQUENCE_OUTPUT: 'sequenceOutput',

  SEQUENCE_SINGLE_INPUT: 'sequenceSingleInput',
  SEQUENCE_SINGLE_OUTPUT: 'sequenceSingleOutput',

  ACTION_BUTTON_OUTPUT: 'actionButtonOutput',

  CONDITION_INPUT: 'conditionInput',
  CONDITION_OUTPUT_TRUE: 'conditionOutputTrue',
  CONDITION_OUTPUT_FALSE: 'conditionOutputFalse',
}